import React from "react";
import { Info } from "lucide-react";

const ValuationBreakdown = ({
  selectedStock,
  formatCurrency,
  handleMouseEnter,
  handleMouseLeave,
  setToast,
}) => {
  return (
    <div className="valuation-section">
      <h4>Valuation Breakdown</h4>
      <div className="valuation-methods">
        <div className="valuation-method">
          <h5>
            Discounted Cash Flow
            <span
              className="info-icon"
              onMouseEnter={(e) =>
                handleMouseEnter("Present value of future cash flows", e)
              }
              onMouseLeave={handleMouseLeave}
            >
              <Info size={16} />
            </span>
          </h5>
          <div className="valuation-details">
            <div className="valuation-value">
              {formatCurrency(selectedStock.dcfValue)}
            </div>
            <div className="valuation-factors">
              <div className="factor">
                <label>Growth Rate (5yr)</label>
                <span>{selectedStock.growthRate.toFixed(1)}%</span>
              </div>
              <div className="factor">
                <label>Terminal Growth</label>
                <span>2.5%</span>
              </div>
              <div className="factor">
                <label>Discount Rate</label>
                <span>{selectedStock.discountRate.toFixed(1)}%</span>
              </div>
            </div>
          </div>
          <div className="sensitivity-link">
            <button
              className="link-button"
              onClick={() =>
                setToast({
                  type: "info",
                  message: "Sensitivity Analysis",
                  subText: "This feature will be available in the next update.",
                })
              }
            >
              View Sensitivity Analysis
            </button>
          </div>
        </div>

        <div className="valuation-method">
          <h5>
            Comparable Company Analysis
            <span
              className="info-icon"
              onMouseEnter={(e) =>
                handleMouseEnter(
                  "Valuation based on peer companies' multiples",
                  e
                )
              }
              onMouseLeave={handleMouseLeave}
            >
              <Info size={16} />
            </span>
          </h5>
          <div className="valuation-details">
            <div className="valuation-value">
              {formatCurrency(selectedStock.comparableValue)}
            </div>
            <div className="valuation-factors">
              <div className="factor">
                <label>Peer Avg P/E</label>
                <span>{selectedStock.peerPE.toFixed(1)}</span>
              </div>
              <div className="factor">
                <label>Peer Avg EV/EBITDA</label>
                <span>{selectedStock.peerEVEBITDA.toFixed(1)}</span>
              </div>
              <div className="factor">
                <label>Adjustment</label>
                <span>
                  {selectedStock.peerAdjustment > 0 ? "+" : ""}
                  {selectedStock.peerAdjustment.toFixed(1)}%
                </span>
              </div>
            </div>
          </div>
          <div className="sensitivity-link">
            <button
              className="link-button"
              onClick={() =>
                setToast({
                  type: "info",
                  message: "Peer Comparison",
                  subText: "This feature will be available in the next update.",
                })
              }
            >
              View Peer Comparison
            </button>
          </div>
        </div>
      </div>

      <div className="intrinsic-value-summary">
        <h5>Final Intrinsic Value Estimate</h5>
        <div className="value-calculation">
          <div className="method-weights">
            <div className="method-weight">
              <span>DCF Valuation (70%)</span>
              <span>{formatCurrency(selectedStock.dcfValue)}</span>
            </div>
            <div className="method-weight">
              <span>Comparable Analysis (30%)</span>
              <span>{formatCurrency(selectedStock.comparableValue)}</span>
            </div>
          </div>
          <div className="final-value">
            <span>Weighted Intrinsic Value</span>
            <span>{formatCurrency(selectedStock.intrinsicValue)}</span>
          </div>
          <div className="discount-calculation">
            <span>Current Price</span>
            <span>{formatCurrency(selectedStock.currentPrice)}</span>
          </div>
          <div className="value-discount">
            <span>Discount to Value</span>
            <span className="high">
              {(
                ((selectedStock.intrinsicValue - selectedStock.currentPrice) /
                  selectedStock.intrinsicValue) *
                100
              ).toFixed(1)}
              %
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValuationBreakdown;
